import { ObjectAny } from '../common';
import Component from '../dom_components/model/Component';

export interface LayerData {
  name: string;
  open: boolean;
  selected: boolean;
  hovered: boolean;
  visible: boolean;
  locked: boolean;
  components: Component[];
}

/**{START_EVENTS}*/
export enum LayerEvents {
  /**
   * @event `layer:root` Root layer changed. The new root component is passed as an argument to the callback.
   * @example
   * editor.on('layer:root', (component) => { ... });
   */
  root = 'layer:root',

  /**
   * @event `layer:component` Component layer is updated. The updated component is passed as an argument to the callback.
   * @example
   * editor.on('layer:component', (component, opts) => { ... });
   */
  component = 'layer:component',

  /**
   * @event `layer:custom` Custom layer event. Object with container and root is passed as an argument to the callback.
   * @example
   * editor.on('layer:custom', ({ container, root }) => { ... });
   */
  custom = 'layer:custom',

  /**
   * @event `layer:render` Component layer rendered. Object with component and rendered layer element is passed as an argument.
   * @example
   * editor.on('layer:render', ({ component, el }) => { ... });
   */
  render = 'layer:render',
}
/**{END_EVENTS}*/

export type LayerEvent = `${LayerEvents}`;

export interface LayerCustomEventData {
  container: HTMLElement | undefined;
  root: Component;
}

export interface LayerRenderEventData {
  component: Component;
  el: HTMLElement;
}

export interface LayerEventCallback {
  [LayerEvents.root]: [Component];
  [LayerEvents.component]: [Component, ObjectAny?];
  [LayerEvents.custom]: [LayerCustomEventData];
  [LayerEvents.render]: [LayerRenderEventData];
}

// need this to avoid the TS documentation generator to break
export default LayerEvents;
